import { Link as RouterLink } from 'react-router-dom';
import { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export const MDXLink = ({ href, className, children, ...props }: ComponentProps<'a'> & { href?: string }) => {
    const { language } = useLanguage();
    const isExternal = href?.startsWith('http');
    const linkClasses = cn('text-primary hover:underline', className);

    // Check if children is likely just text (to avoid adding icons to image links)
    const isTextOnly = React.Children.toArray(children).every(
        child => typeof child === 'string' || typeof child === 'number'
    );

    if (isExternal) {
        return (
            <a href={href} className={linkClasses} target="_blank" rel="noopener noreferrer" {...props}>
                {children}
                {isTextOnly && <ExternalLink className="h-3 w-3 ml-0.5 inline-block opacity-70" aria-hidden="true" />}
                <span className="sr-only">
                    {language === 'de' ? '(öffnet in neuem Tab)' : '(opens in a new tab)'}
                </span>
            </a>
        );
    }

    return href ? (
        <RouterLink to={href} className={linkClasses} {...props}>
            {children}
        </RouterLink>
    ) : (
        <a className={linkClasses} {...props}>
            {children}
        </a>
    );
};
